import React, { createContext, useState, useEffect, useContext } from 'react';
import { AuthContext } from './AuthContext';
import { getInstructorProfile, validateAccessKey } from '../firebase/db';

export const InstructorContext = createContext();

export const InstructorProvider = ({ children }) => {
    const { currentUser } = useContext(AuthContext);
    const [instructor, setInstructor] = useState(null);
    const [accessValid, setAccessValid] = useState(null); // null = loading, true/false = resolved
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!currentUser) {
            setInstructor(null);
            setAccessValid(null);
            setLoading(false);
            return;
        }

        const load = async () => {
            try {
                const profile = await getInstructorProfile(currentUser.uid);
                setInstructor(profile);

                const result = await validateAccessKey(currentUser.uid);
                setAccessValid(result.valid);
            } catch (err) {
                console.error('Error loading instructor context:', err);
                // Default to valid on error to avoid blocking existing users
                setAccessValid(true);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [currentUser]);

    return (
        <InstructorContext.Provider value={{ instructor, accessValid, loading }}>
            {children}
        </InstructorContext.Provider>
    );
};
